import React from "react";
import { ProSidebar, Menu, MenuItem, SidebarHeader, SidebarContent } from 'react-pro-sidebar';
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../utilities/auth";
import { canReadEntity } from "../utilities/adminAccess";
import { useChampionships } from "../utilities/championships";
import { formatPendingCapBadge } from "../utilities/applicationsApi";
import { formatPendingClientFormsBadge } from "../utilities/clientFormsApi";
import { useI18n } from "../utilities/i18n";

const MENU_ITEMS = [
  { path: '/admin', labelKey: 'navMatches', entity: 'matches', match: (p) => p === '/admin' || p.startsWith('/manage_match/') },
  { path: '/tournaments', labelKey: 'navTournaments', entity: 'tournaments', match: (p) => p.startsWith('/tournaments') },
  { path: '/news', labelKey: 'navNews', entity: 'news', match: (p) => p.startsWith('/news') },
  { path: '/teams_management', labelKey: 'navTeams', entity: 'teams', match: (p) => p.startsWith('/teams_management') },
  { path: '/players_management', labelKey: 'navPlayers', entity: 'players', match: (p) => p.startsWith('/players_management') || p.startsWith('/player/') },
  { path: '/applications_managment', labelKey: 'navApplications', entity: 'teams', badge: 'pendingCap', match: (p) => p.startsWith('/applications_managment') || p.startsWith('/manage_application') || p.startsWith('/team_rosters') },
  { path: '/client_forms', labelKey: 'navClientForms', entity: 'client_forms', badge: 'pendingClientForms', match: (p) => p.startsWith('/client_forms') },
  { path: '/black_list', labelKey: 'navBlackList', entity: 'tournaments', match: (p) => p.startsWith('/black_list') },
  { path: '/transfer_windows', labelKey: 'navTransferWindows', entity: 'leagues', match: (p) => p.startsWith('/transfer_windows') },
  { path: '/stadiums_management', labelKey: 'navStadiums', entity: 'stadiums', match: (p) => p.startsWith('/stadiums_management') },
  { path: '/users', labelKey: 'navUsers', entity: 'users', match: (p) => p.startsWith('/users') },
  { path: '/league_disqualifications', labelKey: 'navDisqualifications', entity: 'disqualifications', match: (p) => p.startsWith('/league_disqualifications') },
  { path: '/time_slots', labelKey: 'navTimeSlots', entity: 'matches', match: (p) => p.startsWith('/time_slots') },
  { path: '/match_staff', labelKey: 'navMatchStaff', entity: 'matches', match: (p) => p.startsWith('/match_staff') },
  { path: '/tablo', labelKey: 'navTablo', entity: 'matches', match: (p) => p === '/tablo' },
  { path: '/reports', labelKey: 'navReports', entity: 'reports', match: (p) => p.startsWith('/reports') },
  { path: '/player_stats', labelKey: 'navPlayerStats', entity: 'reports', match: (p) => p.startsWith('/player_stats') },
  { path: '/infographics', labelKey: 'navInfographics', entity: 'infographics', match: (p) => p.startsWith('/infographics') },
  { path: '/player_duplicates', labelKey: 'navDuplicates', entity: 'players', match: (p) => p.startsWith('/player_duplicates') },
  { path: '/league_champions', labelKey: 'navChampions', entity: 'leagues', match: (p) => p.startsWith('/league_champions') },
  { path: '/league_tour_team', labelKey: 'navTourTeam', entity: 'leagues', match: (p) => p.startsWith('/league_tour_team') },
  { path: '/schedule_management', labelKey: 'navSchedule', entity: 'leagues', match: (p) => p.startsWith('/schedule_management') },
];

function SideBar(props) {
  const location = useLocation();
  const pathname = location.pathname;
  const { t } = useI18n();
  const { userData } = useAuth();
  const { pendingCapApplicationsCount, pendingClientFormsCount } = useChampionships();
  const items = MENU_ITEMS.filter((item) => canReadEntity(userData, item.entity));
  const pendingCapBadge = formatPendingCapBadge(pendingCapApplicationsCount);
  const pendingClientFormsBadge = formatPendingClientFormsBadge(pendingClientFormsCount);

  return (
    <ProSidebar collapsed={props.collapsed}>
      <SidebarHeader>
        <div className="sideBarHeader">
          <img src="/images/afl-logo.png" className="sideBarHeaderLogo" alt="AFL" />
          <div className="sideBarHeaderTitle">
            <span className="sideBarHeaderBrand">AFL Admin</span>
          </div>
        </div>
      </SidebarHeader>
      <SidebarContent>
        <Menu iconShape="square">
          {items.map((item) => {
            const badge = item.badge === 'pendingCap'
              ? pendingCapBadge
              : item.badge === 'pendingClientForms'
                ? pendingClientFormsBadge
                : '';
            return (
            <MenuItem key={item.path} active={item.match(pathname)}>
              <Link
                to={item.path}
                className="sidebar-row"
                onClick={() => { if (props.onNavigate) props.onNavigate(); }}
              >
                <span className="sidebar-row-label">{t(item.labelKey)}</span>
                {badge ? <span className="sidebar-badge">{badge}</span> : null}
              </Link>
            </MenuItem>
            );
          })}
          <MenuItem>
            <a
              href="/help/index.html"
              target="_blank"
              rel="noopener noreferrer"
              className="sidebar-row"
              onClick={() => { if (props.onNavigate) props.onNavigate(); }}
            >
              <span className="sidebar-row-label">{t('navHelp')}</span>
            </a>
          </MenuItem>
        </Menu>
    </SidebarContent>
  </ProSidebar>
  );
}

export default SideBar;

